import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Translate, I18n } from 'react-redux-i18n'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import Grid from 'material-ui/Grid'

import { signUp, resetError } from 'modules/users/sign_up'
import { getConfirmationUri, getReferralUri } from 'modules/users/confirmations'
import ValidationErrors from '../validation_errors'
import Group from '../group'
import Submit from '../submit'
import CustomCheckBox from '../custom_check_box'
import parametersSelector from 'selectors/parameters'
import errorsSelector from 'selectors/errors'
import jsonSelector from 'selectors/json'

const password_length_min = process.env.REACT_APP_PASSWORD_LENGTH || 8
const password_regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)./
const email_regexp = /[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*/

const validate = values => {
  const errors = {}
  if (values.email && !email_regexp.test(values.email)) {
    errors.email = true
  }
  if (
    values.password &&
    !(password_regexp.test(values.password) && values.password.length >= password_length_min)
  ) {
    errors.password = <Translate value="hint.passwords" length={password_length_min} />
  }
  return errors
}

const SignUpForm = ({ submitting, handleSubmit, config_parameters, abilities, errors }) => (
  <form onSubmit={handleSubmit}>
    <h2>
      <Translate value="users.sign_up.h" />
    </h2>
    <p className="text-center">
      <Translate value="users.sign_up.have_account" />{' '}
      <Link to="/users/sign_in">
        <b>{I18n.t('users.common.sign_in')}</b>
      </Link>
    </p>

    <br />
    <br />
    <ValidationErrors errors={errors} />

    <Grid container>
      {abilities.can_require_name_on_sign_up && [
        <Grid item md={6} xs={12} key="name">
          <Field
            name="name"
            type="text"
            component={Group}
            label={I18n.t('users.common.name')}
            required
          />
        </Grid>,
        <Grid item md={6} xs={12} key="middle_name">
          <Field
            name="middle_name"
            type="text"
            component={Group}
            label={I18n.t('users.common.middle_name')}
          />
        </Grid>,
        <Grid item md={6} xs={12} key="last_name">
          <Field
            name="last_name"
            type="text"
            component={Group}
            label={I18n.t('users.common.last_name')}
            required
          />
        </Grid>
      ]}
      <Grid item md={6} xs={12}>
        <Field
          name="email"
          type="email"
          component={Group}
          label={I18n.t('users.common.email')}
          required
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <Field
          name="password"
          type="password"
          component={Group}
          label={I18n.t('users.common.password')}
          required
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <Field
          name="password_confirmation"
          type="password"
          component={Group}
          label={I18n.t('users.common.password_confirmation')}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <br />
        <div className="alert alert-dismissible alert-warning">{I18n.t('registration.alert')}</div>
      </Grid>
      <Grid item xs={12}>
        <Field
          name="registration_agreement_terms"
          component={CustomCheckBox}
          label={
            <Translate
              value="registration.agreement_label_html"
              dangerousHTML
              link={config_parameters['links.license_agreement']}
            />
          }
        />
        <Field
          name="registration_agreement_privacy"
          component={CustomCheckBox}
          label={
            <Translate
              value="registration.agreement_label_privacy_html"
              dangerousHTML
              link="https://tokensale.shping.com/privacy-policy.html"
            />
          }
        />
        <Field
          name="registration_agreement_referral"
          component={CustomCheckBox}
          label={
            <Translate
              value="registration.agreement_label_referral_html"
              dangerousHTML
              link="https://tokensale.shping.com/referral-terms-and-conditions.html"
            />
          }
        />
      </Grid>
      <Grid item xs />
      <Grid item xs>
        <Submit
          className="btn-card-login-submit"
          value={I18n.t('users.sign_up.submit')}
          disabled={submitting}
        />
      </Grid>
      <Grid item xs />
    </Grid>
  </form>
)

class SignUpFormContainer extends Component {
  componentWillUnmount() {
    const { resetError } = this.props
    resetError()
  }

  render() {
    return <SignUpForm {...this.props} />
  }
}

const mapStateToProps = state => ({
  config_parameters: parametersSelector(state),
  abilities: jsonSelector('infos.abilities')(state),
  errors: errorsSelector('users.sign_up', 'validation_error')(state),
  referral_code: state.users.sign_up.referral_code
})

const mapDispatchToProps = dispatch => bindActionCreators({ signUp, resetError }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'sign_up',
    onSubmit: (
      {
        registration_agreement_terms,
        registration_agreement_privacy,
        registration_agreement_referral,
        ...props
      },
      dispatch,
      { signUp, referral_code }
    ) =>
      signUp({
        ...props,
        registration_agreement:
          registration_agreement_terms &&
          registration_agreement_privacy &&
          registration_agreement_referral,
        referral_code,
        confirmation_uri: getConfirmationUri(window.location),
        referral_uri: getReferralUri(window.location)
      }).catch(details => {
        throw new SubmissionError(details)
      }),
    validate
  })(SignUpFormContainer)
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/sign_up/form.js